"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.66,7A11,11,0,0,1,19.75,9.35a.5.5,0,1,1-.71.71A9.94,9.94,0,0,0,8.43,7.81l2.4,2.4a7.14,7.14,0,0,1,1.17-.1,7,7,0,0,1,5,2.07.5.5,0,1,1-.71.71A6,6,0,0,0,12,11.11h-.26l9,9A12,12,0,0,0,3.84,3.22Z",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.29,15.08a.49.49,0,0,1-.05.63.5.5,0,0,1-.71,0,2.22,2.22,0,0,0-3.06,0A.5.5,0,0,1,9.76,15a3.24,3.24,0,0,1,4.35-.11l-3.6-3.6a6,6,0,0,0-2.8,1.58A.5.5,0,0,1,7,12.18a7,7,0,0,1,2.7-1.68L7.45,8.24A10,10,0,0,0,5,10.06a.5.5,0,0,1-.71-.71A11,11,0,0,1,6.71,7.5L3.14,3.93A12,12,0,0,0,20.07,20.86ZM12,18.61a.84.84,0,1,1,.84-.84A.84.84,0,0,1,12,18.61Z",
    fill: "#014864"
  }));
};

exports["default"] = _default;